module.exports = __webpack_public_path__ + "static/media/academia_06.fc016cfe.jpg";